import { styled } from "@mui/material/styles";
import { Box, Drawer, Stack } from "@mui/material";

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: "100%",
    maxWidth: "1200px",
    overflow: "hidden",
    backgroundColor: theme.palette.hubColors.greyLightest,
  },
}));

export const StyledProgressBar = styled(Stack, {
  shouldForwardProp: (prop) => !["percent"].includes(prop),
})(({ theme, percent }) => ({
  width: "100%",
  height: "10px",
  borderRadius: "10px",
  background: `linear-gradient(to right, ${theme.palette.hubColors.mainFocus} ${percent}%, ${theme.palette.hubColors.mainFocusLight} ${percent}%)`,
}));

export const SectionCard = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.hubColors.white,
  border: `1px solid ${theme.palette.hubColors.greyLight}`,
  borderRadius: "12px",
  overflow: "hidden",
  boxShadow:
    "0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.04)",
}));

export const SectionHeader = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: "10px",
  padding: "14px 20px",
  borderBottom: `1px solid ${theme.palette.hubColors.greyLight}`,
  backgroundColor: theme.palette.hubColors.greyLightest,
}));

export const SectionHeaderIcon = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "32px",
  height: "32px",
  borderRadius: "8px",
  backgroundColor: theme.palette.hubColors.mainFocusLighter2,
  color: theme.palette.hubColors.mainFocus,
}));

export const SectionBody = styled(Stack)({
  padding: "18px 20px",
  gap: "18px",
});

export const SubHeader = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: "6px",
  paddingBottom: "6px",
  borderBottom: `1px dashed ${theme.palette.hubColors.greyLighter}`,
  color: theme.palette.hubColors.fontMain,
}));

export const FieldGrid = styled(Box, {
  shouldForwardProp: (prop) => !["columns"].includes(prop),
})(({ columns = 3 }) => ({
  display: "grid",
  gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
  gap: "12px",
}));

export const TableShell = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.hubColors.greyLight}`,
  borderRadius: "8px",
  overflow: "hidden",
}));

export const TableHeaderRow = styled(Box, {
  shouldForwardProp: (prop) => !["columns"].includes(prop),
})(({ theme, columns }) => ({
  display: "grid",
  gridTemplateColumns: columns,
  alignItems: "center",
  padding: "10px 14px",
  gap: "12px",
  backgroundColor: theme.palette.hubColors.greyLightest,
  borderBottom: `1px solid ${theme.palette.hubColors.greyLight}`,
}));

export const TableBodyRow = styled(Box, {
  shouldForwardProp: (prop) => !["columns"].includes(prop),
})(({ theme, columns }) => ({
  display: "grid",
  gridTemplateColumns: columns,
  alignItems: "center",
  padding: "12px 14px",
  gap: "12px",
  "&:not(:last-of-type)": {
    borderBottom: `1px solid ${theme.palette.hubColors.greyLighter}`,
  },
}));
